const moment = require('moment-timezone');

angular
  .module('eventPoint')
  .component('eventPoint', {
    template: require('./event-point.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', '$routeParams', 'AuthService', 'envService',
      function EventcodeUsersViewController($rootScope, $scope, $resource, $route, $location, $window, $translate, $routeParams, AuthService, envService) {
        $rootScope.mainmenu = 'eventManagement';
        $rootScope.menu = 'eventPoint';
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.doLogout = $rootScope.gLogout;

        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.events = [];
        this.totalCount = 0;
        this.curPage = 1;
        this.paging = (page) => {
          this.curPage = page;
          $resource(`${APIURL}/admin/event/point`).get({ page: page - 1 }).$promise
            .then((data) => {
              this.events = data.events;
              this.totalCount = data.totalCount;
              this.mileageRatio = data.mileageRatio * 100;
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.paging(1);
        this.addPointEvent = () => {
          resetNewPointEvent();
          jQuery('#modal-event-point-add').modal('show');
        };
        this.getStatus = (event) => {
          const todayMoment = moment();
          const endDate = moment(event.ENDDATE_UTC);
          if (event.USEYN === 'N') {
            return 'D';
          } else if (todayMoment.isAfter(endDate)) {
            return 'E';
          }
          return 'A';
        };
        this.isActive = event => this.getStatus(event) === 'A';
        const resetNewPointEvent = () => {
          const today = moment().format('YYYY-MM-DD');
          this.newPointEvent = { startdate: today, enddate: today };
        };
        this.onDatePick = () => {
          const startDate = jQuery('#inputPickerStart').val();
          const endDate = jQuery('#inputPickerEnd').val();
          this.newPointEvent.startdate = moment(startDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
          this.newPointEvent.endDate = moment(endDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
        };
        this.submit = () => {
          const startMoment = moment(this.newPointEvent.startdate, 'YYYY-MM-DD');
          const endMoment = moment(this.newPointEvent.enddate, 'YYYY-MM-DD');
          const startdate = startMoment.format('YYYY-MM-DD 00:00:00');
          const enddate = endMoment.format('YYYY-MM-DD 23:59:59');
          if (!startMoment.isValid()) {
            alert($translate.instant('올바른 유효기간:시작일을 입력해주세요.'));
            return;
          }
          if (!endMoment.isValid()) {
            alert($translate.instant('올바른 유효기간:만료일을 입력해주세요.'));
            return;
          }
          if (startMoment.isAfter(endMoment)) {
            alert($translate.instant('만료일은 시작일 보다 커야 합니다.'));
            return;
          }
          const pointRatio = parseInt(this.newPointEvent.pointRatio, 10);
          if (!pointRatio && pointRatio !== 0) {
            alert($translate.instant('포인트 적립율을 입력해주세요.'));
            return;
          }
          if (pointRatio < 0 || pointRatio > 1000) {
            alert($translate.instant('포인트 적립율은 0~1000까지 입력 가능합니다.'));
            return;
          }
          $resource(`${APIURL}/admin/event/point`).save({ startdate, enddate, pointRatio }).$promise
            .then(() => {
              resetNewPointEvent();
              jQuery('#modal-event-point-add').modal('hide');
              this.paging(1);
            })
            .catch((err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.delete = (event) => {
          $resource(`${APIURL}/admin/event/point/${event.ID}`).delete().$promise
            .then(() => {
              this.paging(this.curPage);
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/event-point/event-point.component.js